import React, {Component} from "react";

class FilterButton extends Component {
  constructor(props) {
    super(props);
    this.render = this.render.bind(this);
  }

  toggleFilter = () => {
    this.props.toggleFilter(this.props.type, this.props.choice);
  };

  render() {
    if ( this.props.type === 'plugIDs' ) {
      let fb_class = 'fb-channel';
      if (parseInt(this.props.choice, 16) % 8 === 0) {
        fb_class = 'fb-plugid';
      }
      return (
        <button className={`filterButton ${this.props.active} ${fb_class}`} type="submit"
                onClick={() => this.toggleFilter()}>
          {this.props.choice}
        </button>
      )
    }
    else {
      return (
        <button className={`filterButton ${this.props.active} fb-${this.props.choice}`} type="submit"
                onClick={() => this.toggleFilter()}>
          {this.props.choice}
        </button>
      )
    }
  }
}

export default FilterButton;

